import { type CSSObject } from '@emotion/react';

export const useStatusStyles = (): Record<'icon', CSSObject> => ({
  icon: {
    flexShrink: 0,
  },
});
